import {FC, useContext, useEffect, useState} from "react";
import {ContextAppState} from "@app/context.ts";
import {TokenWithAmount} from "@pages/account-send/index.tsx";


export type SelectProps = {
    tokenWithAmount: TokenWithAmount[];
    onSelect: (token: TokenWithAmount) => void;
}


export const Select: FC<SelectProps> = ({tokenWithAmount, onSelect}) => {
    const appState = useContext(ContextAppState);

    const [query, setQuery] = useState("");

    const filtered = tokenWithAmount.filter(item =>
        item.token.name.toLowerCase().includes(query.toLowerCase()) ||
        item.token.symbol.toLowerCase().includes(query.toLowerCase())
    );

    // useEffect(() => {
    //     if (appState.type === 'Telegram') {
    //         // @ts-ignore
    //         const tg = window.Telegram.WebApp;
    //         tg.BackButton.show();
    //         const handleBackClick = () => {
    //             window.history.back();
    //         };
    //         tg.BackButton.onClick(handleBackClick);
    //
    //         return () => {
    //             tg.BackButton.hide();
    //             tg.BackButton.offClick(handleBackClick);
    //         };
    //     }
    // }, [appState.type]);

    return (
        <div
            className="max-w-md mx-auto p-6 bg-transparent backdrop-blur-sm"
        >
            <h2 className="text-xl font-bold text-orange-400 mb-5 text-center">
                Select a Token
            </h2>

            <input
                type="text"
                placeholder="Search by name or symbol"
                className="w-full px-4 py-2 mb-5 border border-orange-200 rounded-xl text-sm text-orange-800 placeholder-orange-800 focus:outline-none focus:ring-2 focus:ring-orange-300 transition"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
            />

            <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
                {filtered.map((twa) => {
                    const token = twa.token;
                    const amount = twa.amount;

                    return (
                        <button
                            key={token.mint}
                            onClick={() => onSelect(twa)}
                            className="flex items-center w-full px-4 py-3 rounded-xl border border-yellow-500 hover:border-orange-300 hover:bg-orange-50 transition text-left"
                        >
                            {token.image ? (
                                <img
                                    src={token.image}
                                    alt={token.symbol}
                                    className="h-8 w-8 rounded-full mr-3 border border-orange-200"
                                />
                            ) : (
                                <div
                                    className="h-8 w-8 rounded-full mr-3 bg-orange-200 text-orange-800 flex items-center justify-center font-bold text-sm border border-orange-300">
                                    {token.symbol.charAt(0)}
                                </div>
                            )}

                            <div className="flex-1">
                                <div className="text-sm font-semibold text-orange-200">{token.name}</div>
                                <div className="text-xs text-gray-500">{token.symbol}</div>
                            </div>

                            <div className="text-sm font-mono text-orange-200">
                                {amount.toFixed(4)}
                            </div>
                        </button>
                    );
                })}

                {filtered.length === 0 && (
                    <div className="text-center text-sm text-orange-400 py-4">
                        No tokens found
                    </div>
                )}
            </div>
        </div>
    );
};